module.exports = __webpack_public_path__ + "static/media/Anova-LightItalic.707e3564.woff2";